import '@/pages/intelligence/assets/scss/MarketProfile/MobileGames/index.scss';
import './index.scss';
import React, { useMemo, useState, useCallback, useEffect } from 'react';
import { history } from 'umi';
import commonEn from '@/pages/intelligence/_locales/en-US/common';
import commonCn from '@/pages/intelligence/_locales/zh-CN/common';
import moment from 'moment';
import { Justify, Row, Col, Card } from 'tea-component';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import DynamicTable from '@intelligence/pages/MarketProfile/components/DynamicColTable/Table';
import { getCountryFlag } from '@/pages/home/_config/countries';
import { TDataSource } from '../type';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';
import NoData from '@intelligence/components/NoData';
import { MOBILE_CONFIG } from '../_config/mobile';
import { METRICS_MAP } from '../constants';
import useCardConfig from '../hooks/useCardConfig';
import useMobileTable from '../hooks/useMobileTable';
import GuideGenreMarketProfile, {
  GENRE_MARKET_PROFILE_GUIDE_CLASSNAMES,
} from '@intelligence/components/UserGuide/GenreMarketProfile';
import filtersConfig from '@intelligence/_config/components/filters';
import { handleFilterToApiParams } from '../_config/filterCfg';
import useInitFilterHook from '@intelligence/hooks/useInitFilterHook';
import CommonFilter from '@intelligence/components/CommonFilter';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import useSetQueryDefinition, {
  COND_PARAMS,
  FULL_GENRE,
} from '@intelligence/hooks/useQueryDefinition';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import ExportTable from '@/pages/intelligence/components/ExportTable';
import * as filterKeyMap from '@intelligence/components/Filter/FilterBase/_config';
import { calculGrowth, convertStringToCountries, sortMetrics } from '../_util';
import Loading from '@intelligence/components/Loading';
import ApnnieNochange from '@/pages/intelligence/assets/svg/dataSource/appnnie.svg';
import SensorTower from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import Apple from '@/pages/intelligence/assets/svg/dataSource/apple.svg';
import Android from '@/pages/intelligence/assets/svg/dataSource/android.svg';
import GlobalPerformanceCard from '../components/GlobalPerformanceCard';
import { TPlatformType, TSourceType } from '../components/GlobalPerformanceCard/type';
import PlatformCard from '../components/PlatformCard';
import ChartCard from '../components/ChartCard';
import useChartConfig from '@intelligence/pages/MarketProfile/hooks/useChartConfig';
import SearchTable from '@intelligence/pages/MarketProfile/components/MarketTableCard/SearchTable';
import useCountriesHooks from '@intelligence/pages/MarketProfile/hooks/useCountriesHooks';
import { useCachedCountryMap } from '../hooks/useCachedCountryMap';
import { resetCacheUpdateCount } from '../_config/cache';
import { marketProfile } from '@intelligence/v3/constants/downloadLogPoint';

const GRANULARITY = 'monthly';
const PAGE_ID = 'MarketProfilMobile';

const IconMap: Record<TSourceType | TPlatformType, string> = {
  sensortower: SensorTower,
  appannie: ApnnieNochange,
  apple: Apple,
  android: Android,
};

export default function MobileGames(props: any) {
  const {
    regionsCountries,
    entityType,
    activeId,
    pageId = PAGE_ID,
  } = props;

  const filterConfig = useMemo(() => filtersConfig[pageId], [pageId]);

  // const initGenres = filterConfig?.defaultFilterValue?.[filterKeyMap.DIGITAL_SEGMENT_MULTIPLE]?.value;
  // const initRegions = filterConfig?.defaultFilterValue?.[filterKeyMap.REGION]?.markets;
  // const initDataSource = filterConfig?.defaultFilterValue?.[filterKeyMap.DATASOURCESIM]?.value;

  const { formatMessage, locale } = useIntlExtend();
  // const [dataSource, setDataSource] = useState<TDataSource>('appannie');
  // const [dataSource, setDataSource] = useState<TDataSource>(initDataSource);
  // const [regions, setRegions] = useState<string[]>(initRegions);
  // const [genres, setGenres] = useState<string[]>(initGenres);
  const [isOpenDownload, setIsOpenDownload] = useState(false);
  // 筛选器默认值配置
  const filterCfg = {
    filterKeyList: filterConfig?.filterKeyList,
    defaultValue: filterConfig?.defaultFilterValue,
    showConfirmButton: false,
    isCustomLayoutFilter: true,
    specialParams: {
      defalutMarket: ['global'], // 没取到交集用的默认值
      disableNoChina: true,
      entityType,
    },
  };
  /** 筛选器value数据 **/
  const [filterValue, setFilterValue] = useState<any>(filterCfg?.defaultValue || {});

  const dataSource: TDataSource = filterValue?.[filterKeyMap.DATASOURCESIM]?.value;
  const regions = filterValue?.[filterKeyMap.REGION]?.markets;
  const genres = filterValue?.[filterKeyMap.DIGITAL_SEGMENT_MULTIPLE]?.value;

  // console.debug('filterConfig', { filterConfig, filterValue, genres, regions, dataSource });

  const currentConfig = {
    tableFormatter: MOBILE_CONFIG.mobile.tableFormatter,
    keyMap: MOBILE_CONFIG.common.keyMap,
    metricCol: MOBILE_CONFIG.mobile.tableMetricList,
    firstCol: MOBILE_CONFIG.mobile.firstCol,
    specialCol: MOBILE_CONFIG.mobile.specialCol,
    getLinkurl: MOBILE_CONFIG.common.getLinkUrl,
  };

  // 使用统一全局存储数据
  const { condDatas, filterLoading } = useSetQueryDefinition({ ...COND_PARAMS.mobileMainGenre, ...COND_PARAMS.genreMap });

  // 获取主品类筛选器选项
  const mainGenreOptions = useMemo(() => {
    if (filterLoading) return [];
    const genreListTemp = condDatas?.mobileMainGenre || [];
    return genreListTemp?.map((itemValue: string) => {
      const iegGenreList = FULL_GENRE?.ieg || [];
      const itemGenreObj = iegGenreList?.find((item: any) => item?.main_genre?.genre == itemValue);
      let textValue = itemValue;
      if (itemGenreObj) {
        textValue =
          locale === LANGUAGE_CN
            ? itemGenreObj?.main_genre?.genre_cn
            : itemGenreObj?.main_genre?.genre_en;
      }
      return {
        value: itemValue,
        text: textValue,
      };
    });
  }, [condDatas, filterLoading, locale]);

  // const countryMap = useQueryDefinition('countryMap') || [];
  const { countryMap, isLoading: countryMapLoading } = useCachedCountryMap();

  const getTrueKey = (sortKey: string) => {
    const len = sortKey.length;

    return {
      trueKey: sortKey.slice(0, len - 2),
      sortType: sortKey.slice(len - 1),
    };
  };

  /**
   * 对列表数据进行排序处理
   * @param _list - 待排序的原始数据列表
   * @param sortKey - 排序的键名
   * @param sortOrder - 排序方向('asc'/'desc')
   * @param noRank - 是否不添加排名
   * @param excludedItem - 不参与排序的项
   * @returns 排序后的数组，包含被排除项和已排序项
   *
   * 函数会将列表分为两部分:
   * 1. excludedItem中指定的项会被排除在排序之外
   * 2. 其余项按照指定的sortKey和sortOrder进行排序
   * 最终返回合并后的数组，其中每项可能包含rank信息
   */
  const sortFn = (_list, sortKey: string, sortOrder, noRank: boolean, excludedItem: string[]) => {
    const { trueKey, sortType } = getTrueKey(sortKey);
    const { keyMap } = currentConfig;

    const getRankArr = () => {
      const includeArr = [];
      const excludeArr = [];
      _list.forEach((item) => {
        if (excludedItem.includes(item[keyMap.abbr])) {
          excludeArr.push({
            id: '-',
            ...item,
          });
        } else {
          includeArr.push(item);
        }
      });
      return {
        includeArr,
        excludeArr,
      };
    };

    // TODO: 此处排序的逻辑待优化，上层传入 state 有问题，特殊处理映射
    const findMetric = (metricList, key: string, typeStr: 'value' | 'value_ratio') => {
      const find = metricList?.find((item) => {
        const realMetric = item.metric?.split('_')?.[1];

        if (typeStr === 'value') {
          // console.debug('find in', { find, key, typeStr, metricList, realMetric });
          return key?.includes(realMetric);
        }

        // return item.metric === key?.split('_ratio')?.[0]
        const ratioKey = key?.split('_ratio')?.[0];

        // console.debug('find', { find, key, typeStr, metricList, realMetric });
        return ratioKey?.includes(realMetric);
      });

      if (find) return find?.[typeStr] || 0;
      return 0;
    };

    // 对比方法
    const compareFun = (a: any, b: any) => {
      // const typeStr = sortType !== '1' ? keyMap.metricValue : keyMap.metricRatio;
      const typeStr = !sortKey?.includes('ratio') ? keyMap.metricValue : keyMap.metricRatio;
      const metricListName = keyMap.metricList;
      // const aValue = findMetric(a[metricListName], trueKey, typeStr);
      // const bValue = findMetric(b[metricListName], trueKey, typeStr);
      const aValue = findMetric(a[metricListName], sortKey, typeStr);
      const bValue = findMetric(b[metricListName], sortKey, typeStr);

      return sortOrder === 'desc' ? bValue - aValue : aValue - bValue;
    };

    const { includeArr, excludeArr } = getRankArr();
    const result = includeArr.sort(compareFun)?.map((item, index) =>
      Object.assign(item, {
        id: noRank ? null : index + 1,
      }),
    );

    return [...excludeArr, ...result];
  };

  const getEmptyMetricObj = (currentSource, metric) => ({
    value: '-',
    // growth_ratio: '-',
    value_ratio: '-',
    title: '-',
    // metric,
    metric: `${currentSource}_${metric}`,
    source: currentSource,
  });

  // 对指标数值进行处理
  const getMetricConfig = (item, sortKey: string, sourceName, gameCountObj?: any) => {
    // const { growth_ratio: growth, metric, value } = item || {};
    const { value_ratio, metric, value } = item || {};

    return {
      align: 'center',
      // growth_ratio: growth,
      // value_ratio,
      value_ratio: Number.isFinite(item?.value_ratio)
        ? calculGrowth({ currNum: item.value, preNum: item.value_ratio })
        : item?.value_ratio,
      value,
      gameCount: gameCountObj?.value || 0,
      isNeedSort: metric === sortKey,
      metric: `${sourceName}_${metric}`,
      source: sourceName,
      // @ts-ignore
      title: METRICS_MAP[metric],
    };
  };

  const getTargetCountryMap = (map: any[]) => {
    const tmpObj: Record<string, any> = {};
    map?.forEach((item) => {
      tmpObj[item.country_name_abbre.toLowerCase()] = item;
    });
    return tmpObj;
  };

  const getMarketLabel = (key, countryMap) => {
    if (key === 'global') {
      return {
        market: key,
        marketEn: commonEn.dbi_global,
        marketCn: commonCn.dbi_global,
      };
    }
    if (key === 'global_wo_china') {
      return {
        market: key,
        marketEn: commonEn.dbi_global_wo_china,
        marketCn: commonCn.dbi_global_wo_china,
      };
    }
    return {
      market: key,
      marketEn: countryMap?.[key]?.country_name_en,
      marketCn: countryMap?.[key]?.country_name_cn,
    };
  };

  const transData2TableList = ({ fetchList = [], sortKey, currentSource, countryMap }) => {
    const targetCountryMap = getTargetCountryMap(countryMap) || {};
    const tmpObj: any = {};
    let realSource = ''; // 这里由于 currentSource 接入筛选器后，状态更新有延迟，进行特殊处理

    fetchList.forEach((item) => {
      const { market, metric, source } = item || {};
      if (!Object.prototype.hasOwnProperty.call(tmpObj, market)) {
        tmpObj[market] = {};
      }

      tmpObj[market][`${source}_${metric}`] = item;
      realSource = source;
    });

    const result = Object.keys(tmpObj).map((key, idx) => {
      const tmpMetricObj = tmpObj[key];

      const tmpRevenue =
        tmpMetricObj[`${realSource}_revenue`] || getEmptyMetricObj(realSource, 'revenue');
      const tmpDownload =
        tmpMetricObj[`${realSource}_download`] || getEmptyMetricObj(realSource, 'download');
      // const tmpGameCount =
      //   tmpMetricObj[`${realSource}_game_count`] || getEmptyMetricObj(realSource, 'game_count');

      const tmpGameCount = tmpMetricObj[`${realSource}_game_count`];

      const tmpArr = [
        getMetricConfig(tmpRevenue, sortKey, realSource, tmpGameCount),
        getMetricConfig(tmpDownload, sortKey, realSource, tmpGameCount),
      ];

      return {
        country_img: getCountryFlag(key),
        imgType: 'mobile',
        metric_list: tmpArr,
        abbr: key,
        ...getMarketLabel(key, targetCountryMap),
      };
    });

    // console.debug('tmpObj', {
    //   tmpObj,
    //   result,
    //   currentSource,
    //   sortKey,
    //   fetchList,
    //   tableAction,
    //   selectedList: tableAction?.selectedList,
    // });

    return result;
  };

  const tableFormatter = ({
    fetchList = [],
    sortKey,
    sortOrder,
    currentSource,
    countryMap,
    isInit,
  }) => {
    const tableArr = transData2TableList({
      fetchList,
      sortKey,
      currentSource,
      countryMap,
    });

    const targetList = isInit ? tableArr : fetchList;

    // console.debug('transData2', { fetchList, tableArr, targetList });

    return {
      original: targetList,
      formatted: sortFn(targetList, sortKey, sortOrder, false, ['global_wo_china', 'global', 'ww']),
    };
  };

  const {
    fetchParams,
    isTableLoading,
    tableData,
    tableAction,
    tableActionDispatch,
    handleFilteredArr,
    handleTableCheck,
    handlePagingChange,
    handleTableSortChange,
    getIsHideCol,
    updateData: updateTableData,
  } = useMobileTable({
    pageId,
    dataSource,
    // dataSource: 'appannie',
    granularity: GRANULARITY,
    regions,
    genres,
    // defaultSortKey: 'appannie_revenue',
    defaultSortKey: `${dataSource}_revenue`,
    defaultChekckNumberRange: [0, 5],
    tableFormatter: (params) => {
      const res = tableFormatter({ ...params, currentSource: dataSource });
      // console.debug('tableFormatter inject', { ...params });

      return res;
    },
    getLinkUrl: currentConfig.getLinkurl,
    // keyMap: currentConfig.keyMap,
    countryMap,
  });

  const {
    metricConfig: noSortedMetricConfig,
    platformConfig: noSortedPlatformConfig,
    metricLoading,
    platformLoading,
  } = useCardConfig({
    fetchParams,
    dataSource,
    granularity: GRANULARITY,
    regions,
    genres,
  });

  const metricConfig = sortMetrics(noSortedMetricConfig);
  const platformConfig = sortMetrics(noSortedPlatformConfig);

  // const selectedList = tableAction?.selectedList;
  const selectedKeys = tableAction?.selectedList?.map((item) => {
    return {
      // ...item,
      color: item?.color,
      gameId: item?.marketEn,
      marketEn: item?.market,
    };
  });

  const {
    mainSegment,
    setMainSegment,
    chartType,
    setChartType,
    chartLoading,
    setChartLoading,
    chartData,
  } = useChartConfig({
    selectedList: tableAction?.selectedList,
    fetchParams,
    dataSource,
    countryMap,
  });

  const { countries } = useCountriesHooks({ entity_type: 'mobile' });

  // console.debug('pageData', {
  //   tableData,
  //   dataSource,
  //   chartData,
  //   chartType,
  //   // metricConfig,
  //   // platformConfig,
  //   countries,
  //   countryMap,
  //   tableAction,
  //   tableActionDispatch,
  // });

  /**
   * 筛选器统一值处理后，confirm回调
   */
  const fetchFilterChange = (payload: any, apiValue: any) => {
    // console.debug('payloadpayload', payload);
    // 筛选器value转为接口参数
    const params = handleFilterToApiParams(fetchParams, payload, apiValue);
    updateTableData({ params, isInit: true });
  };

  // filter公共hooks，暴露全局统一处理filterValue方法，再调接口
  const { updateFilterDatas } = useInitFilterHook({
    entityType,
    filterCfg,
    filterValue,
    setFilterValue,
    filterConfirm: fetchFilterChange,
    fetchParams,
  });

  // const getGenreDetailPath = () => {};

  const onNameClick = (type: string, item: any) => {
    const linkUrl = currentConfig.getLinkurl({
      marketName: item[currentConfig.keyMap.gametitle],
      marketAbbr: item[currentConfig.keyMap.abbr],
      pageId,
      source: dataSource,
      isAnnie: '0',
    });

    const condiStr = 'global,global_wo_china,ww';
    const noJumpCondi = condiStr.split(',').includes(item?.market);

    if (noJumpCondi) {
      return;
    }

    linkUrl && history.push(linkUrl);
  };

  const handleDateColFormat = (title: string) => moment(title).format('YYYY-MM');

  // 转化下载的参数
  const getDownloadFetchParams = useCallback(() => {
    const paramsTmp: {
      [key: string]: any;
    } = {
      regionOptions: regionsCountries,
      regions: fetchParams.regions,
      dataSource,
      fetchParams,
      ...fetchParams,
      tableAction,
      tableData,
    };
    return paramsTmp;
  }, [fetchParams, dataSource, tableAction, tableData]);

  const lineColor = selectedKeys?.map((i) => i?.color);
  const lineTrendData = chartData;

  function processMetricList(tableData, metricKey) {
    // console.debug('tableMetrcList', { tableData, metricKey });

    return tableData
      ?.filter((country) => {
        // Filter out global aggregations - they should not be displayed on the map
        return country?.market !== 'global' && country?.market !== 'global_wo_china';
      })
      ?.map((country) => {
        if (!country?.metric_list?.length) return null;

        const targetMetric = country.metric_list.find((mItem) =>
          mItem?.metric?.includes(metricKey),
        );

        return targetMetric
          ? {
            ...targetMetric,
            abbr: country.abbr,
            name: country.marketEn || country.market,
            market: country.market,
            marketEn: country.marketEn,
            marketCn: country.marketCn,
          }
          : null;
      })
      .filter(Boolean);
  }

  const digitalList = processMetricList(tableData, 'revenue');
  const physicalList = processMetricList(tableData, 'download');

  const tableLoadingCondi = filterLoading || isTableLoading || countryMapLoading;

  const chartLoadingCondi =
    (chartType === 'discount-chart' && chartLoading && countryMapLoading) ||
    (chartType === 'chart-map' && isTableLoading && countryMapLoading) ||
    tableLoadingCondi;

  useEffect(() => {
    return () => {
      // 卸载重置缓存计数
      resetCacheUpdateCount();
    };
  }, []);

  return (
    <div className="dbi-marketprofile--mobilegames">
      <MarqueeBanner />
      {/* 筛选器 */}
      <CommonFilter
        timeFilterValues={{
          type: fetchParams?.granularity || 'monthly',
          value: [fetchParams?.start_date, fetchParams?.end_date],
        }}
        filterConfirm={(...params: any) => {
          updateFilterDatas(...params);
        }}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
        filterCfg={filterCfg}
        defaultInputList={filterConfig?.defaultInputList}
        regionOptions={regionsCountries}
        mainGenreOptions={mainGenreOptions}
        isBasicLoading={filterLoading}
      />
      {/* Global Perfromance Chart Card 占位 */}
      <Row className="mobilegames-wrap">
        <Col span={12}>
          <Card>
            <Card.Body>
              <div className="mobilegames-cont mobilegames-cont--noline">
                {metricLoading ? (
                  <div className="total-loading">
                    <Loading content={formatMessage({ id: 'common_loading' })} />
                  </div>
                ) : (
                  <GlobalPerformanceCard
                    datas={metricConfig}
                    needCustomIcon
                    icon={IconMap[dataSource]}
                  />
                )}
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col span={12}>
          <Card>
            <Card.Body>
              <div className="mobilegames-cont">
                {platformLoading ? (
                  <div className="total-loading">
                    <Loading content={formatMessage({ id: 'common_loading' })} />
                  </div>
                ) : (
                  <PlatformCard datas={platformConfig} />
                )}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* 地图组件 */}
      <CardSlotV2
        iconList={[
          { id: 1, context: 'dbi_world_map_chart', icon: 'chart-map', value: 'chart-map' },
          { id: 2, context: 'dbi_line_chart', icon: 'discount-chart', value: 'discount-chart' },
        ]}
        title={formatMessage({ id: 'dbi_market_global_perf' })}
        activeTab={chartType}
        getChange={(type: string) => {
          setChartType(type);
          if (chartType === 'chart-map') {
          }
        }}
        className="dbi-marketprofile-chart-card-wrapper"
      >
        {chartLoadingCondi ? (
          <div className="total-loading" style={{ fontSize: 14, height: 410 }}>
            <Loading content={formatMessage({ id: 'common_loading' })} />
          </div>
        ) : selectedKeys?.length === 0 && chartType === 'discount-chart' ? (
          <div style={{ fontSize: 14, height: 410 }}>
            <NoData content={formatMessage({ id: 'common_nodata' })} />
          </div>
        ) : (
          <div key={`${pageId}-${activeId}-${chartType}`}>
            <ChartCard
              pageId={pageId}
              chartType={chartType}
              activeTab={chartType}
              // chartType={'discount-chart'}
              options={[
                {
                  text: formatMessage({ id: 'dbi_revenue_$' }) as string,
                  value: 'Revenue',
                },
                {
                  text: formatMessage({ id: 'dbi_downloads' }) as string,
                  value: 'Downloads',
                },
              ]}
              regionsCountries={regionsCountries}
              // selectedKeys={selectedList}
              selectedKeys={selectedKeys}
              selectedKeysColor={lineColor}
              lineTrendData={lineTrendData}
              mainSegment={mainSegment}
              onSegmentChange={setMainSegment}
              digitalVal={digitalList}
              physicalVal={physicalList}
            />
          </div>
        )}
      </CardSlotV2>

      {/* 搜索 &下载 功能占位 */}
      <Justify
        className="dbi-tablecard-justify marketTop-searchbody"
        right={
          <>
            <SearchTable
              countrieSelectList={countries}
              allCountriesList={countries}
              handleSearchData={(value) => {
                if (value === '') {
                  handleFilteredArr('');
                } else {
                  const filteredCountries = convertStringToCountries({
                    searchKey: value,
                    allCountries: countries,
                  });

                  handleFilteredArr(filteredCountries);
                }
              }}
              regionsCountries={regionsCountries}
            />
            {pageId !== 'MarketProfilAnnualReport' && (
              <ExportTable
                entityType={entityType}
                tableParams={getDownloadFetchParams()}
                businessType={`${entityType}MarketProfileTopCharts`}
                isDisableDownload={isTableLoading || filterLoading}
                isShowMaxDownloadRowsTips={false}
                downloadModalSize={900}
                isDisableDataAmount={true}
                newStyleFileName={`Market Profile_Mobile Games`}
                pageId={pageId}
                useWebDownload={true}
                downloadKey={`${entityType}MarketProfileTopCharts`}
                isUseFormDownload={true}
                total={tableAction.total}
                downloadLogConfigKey={marketProfile?.[entityType]}
              />
            )}
          </>
        }
      />

      <CardSlotV2 iconList={[]}>
        {currentConfig.firstCol && countryMap.length > 0 ? (
          <DynamicTable
            key={'marketProfile'}
            isExpandable={false}
            tableData={tableData}
            // isLoading={isTableLoading}
            isLoading={tableLoadingCondi}
            entityType={entityType}
            // tableSelected={selectedList}
            tableSelected={tableAction?.selectedList}
            tableSelectedAll={tableAction.SelectionAll}
            total={tableAction.total}
            isNotPageableAuto={false}
            uniqueKey={'marketEn'}
            sortKey={tableAction.sortKeyLabel}
            sortOrder={tableAction.sortOrder}
            pageSize={tableAction.pageSize}
            pageIndex={tableAction.pageIndex}
            keyMap={currentConfig.keyMap}
            getDateColFormat={handleDateColFormat}
            metricCol={currentConfig.metricCol}
            firstCol={currentConfig.firstCol}
            specialCol={currentConfig.specialCol}
            getIsHideCol={getIsHideCol}
            pageSizeOptions={[10, 20, 30, 50, 100, 200]}
            onPagingChange={handlePagingChange}
            className={GENRE_MARKET_PROFILE_GUIDE_CLASSNAMES.ELEMENT1}
            onSortChange={handleTableSortChange}
            onTableCheckboxChange={(list, status) => {
              handleTableCheck(list, status);
              setChartType('discount-chart');
            }}
            onGameItemClick={onNameClick}
            // getGenreDetailPath={getGenreDetailPath}
            scrollMinWidth={entityType === 'pc' || entityType === 'console' ? 1400 : 'auto'}
          />
        ) : (
          <div style={{ fontSize: 14, height: 340 }}>
            <NoData content={formatMessage({ id: 'common_nodata' })} />
          </div>
        )}
        {tableLoadingCondi ? <GuideGenreMarketProfile /> : null}
      </CardSlotV2>
      {/* 下载弹窗 */}
      {/* {isOpenDownload && (
        <MarketDownloadSettings
          isOpen={isOpenDownload}
          onClose={() => setIsOpenDownload(false)}
          pageId={pageId}
          fetchParams={fetchParams}
          selectedKeys={[]}
          tableData={tableData}
        />
      )} */}
    </div>
  );
}
